import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom"; // for ?token=abc
import { acceptInvite } from "././../api/api";

const AcceptInvite = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !password) return alert("Name and password are required");

    setLoading(true);
    try {
      const res = await acceptInvite(token, name, password);
      alert(res.msg);
      // redirect to login page or dashboard
      window.location.href = "/login";
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.msg || "Failed to accept invitation");
    }
    setLoading(false);
  };

  if (!token) return <p>Invalid invitation link.</p>;

  return (
    <div className="card mx-auto mt-5" style={{ maxWidth: "400px" }}>
      <div className="card-body">
        <h5 className="card-title mb-3">Accept Invitation</h5>
        <form onSubmit={handleSubmit}>
          <div className="mb-2">
            <input
              type="text"
              className="form-control"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="mb-2">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button className="btn btn-primary w-100" type="submit" disabled={loading}>
            {loading ? "Accepting..." : "Accept Invitation"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AcceptInvite;
